import { commonAPI } from "../services/CommonAPIService";

let ErrorSource = "CURONEXTPORTAL"
export const ErrorLog = async (userId = null, mobileNumber = null, requestJSON = null, uri, errorNumber, errorSummary, errorDescription, fileClassName, functionName) => {
    try {
      if(!uri || !errorNumber || !errorSummary || !errorDescription || !fileClassName || !functionName ){
        console.error("One of the arguments uri || errorNumber || errorSummary || errorDescription || fileClassName || functionName is null.")
        return;
      }
  
      const ErrorRequest = {
        "userId": userId,
        "mobileNumber": mobileNumber,
        "requestJSON": JSON.stringify(requestJSON),
        "uri": uri,
        "errorNumber": errorNumber,
        "errorSource": ErrorSource,
        "errorSummary": errorSummary,
        "errorDescription": JSON.stringify(errorDescription),
        "fileClassName": fileClassName,
        "functionName": functionName,
      }
      console.log("json", ErrorRequest)
      const errorResponse = await commonAPI("ErrorLogMaster", ErrorRequest);
      console.log("error logged", errorResponse);
      
    } catch (error) {
  
    }
    
  }
  